import { activosSections } from './activosSections';

export const activosManual = {
  id: 'mod-activos',
  title: 'Activos fijos',
  isVisible: (ctx) => ctx.canSeeActivos,
  intro:
    'Registro de activos, ubicación por área, clasificación jerárquica y depreciación. Documentación detallada por pantalla del menú Activos.',
  sections: activosSections,
};
